import { FC } from 'react';
import { useTrans, Trans } from 'base/utils/i18n';
import { ReferralTitle } from 'mod/referral/ReferralTitle';
import { CardList } from 'mod/referral/CardList';
import { RouteEnum } from 'pro/config/routers';
import site from 'pro/config/site';
import { useRouter } from 'next/router';
import Iconfont from '@base/lib/Iconfont';

type IReferralProcessProps = {
    className?: string;
};

export const ReferralProcess: FC<IReferralProcessProps> = props => {
    const { className } = props;
    const { t } = useTrans();
    const router = useRouter();

    return (
        <div className={className}>
            <ReferralTitle>{t('web_referral_process')}</ReferralTitle>
            <CardList
                list={[
                    {
                        icon: 'file-asset/file/87bd59139d597bba92ac0cdb83e5348e.svg',
                        title: t('web_referral_process_step1', { brand: site.brand }),
                        // desc: t('web_referral_process_step1_description'),
                        desc: (
                            <Trans
                                i18nKey="web_referral_process_step1_description"
                                components={{
                                    a: <a onClick={() => router.push(RouteEnum.REFER_A_FRIEND)}/>
                                }}
                            />
                        )
                    },
                    {
                        icon: 'file-asset/file/273ef3fb294acd44b40113d6d85b4538.svg',
                        title: t('web_referral_process_step2'),
                        desc: (
                            <Trans
                                i18nKey="web_referral_process_step2_description"
                                components={{
                                    ShareIcon: <Iconfont className={'icon-minimized'}/>
                                }}
                            />
                        ),
                    },
                    {
                        icon: 'file-asset/file/7252463c5f55255041528b8af22548fd.svg',
                        title: t('web_referral_process_step3'),
                        desc: t('web_referral_process_step3_description', { brand: site.brand }),
                    },
                ]}
            />
        </div>
    )
};
